export default "__VITE_ASSET__V12R67qm__"